const EXCHANGE_BY_KEY = {
  upbit: {
    key: 'upbit',
    label: '업비트',
    labelKey: 'exchange.upbit',
    link: 'https://upbit.com/home'
  },

  bithumb: {
    key: 'bithumb',
    label: '빗썸',
    labelKey: 'exchange.bithumb',
    link: 'https://www.bithumb.com/react/'
  },

  coinone: {
    key: 'coinone',
    label: '코인원',
    labelKey: 'exchange.coinone',
    link: 'https://coinone.co.kr/'
  },

  digitalx: {
    key: 'digitalx',
    label: '디지털엑스',
    labelKey: 'exchange.digitalx',
    link: 'https://digitalx.miraeasset.com'
  },

  gopax: {
    key: 'gopax',
    label: '고팍스',
    labelKey: 'exchange.gopax',
    link: 'https://www.gopax.co.kr/'
  }
}

const DEFAULT_FOOTER_EXCHANGE_ORDER = ['upbit', 'bithumb', 'coinone', 'korbit', 'gopax']

const FOOTER_EXCHANGE_ORDER_BY_TARGET = {
  ASP: DEFAULT_FOOTER_EXCHANGE_ORDER,
  MSTOCK: ['digitalx', 'bithumb', 'coinone', 'gopax'],
  jb: ['gopax', 'upbit', 'bithumb', 'coinone', 'korbit']
}

export const getFooterExchanges = (appTarget) => {
  const order = FOOTER_EXCHANGE_ORDER_BY_TARGET[appTarget] ?? DEFAULT_FOOTER_EXCHANGE_ORDER

  return order.map((key) => EXCHANGE_BY_KEY[key]).filter(Boolean)
}
